<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" max-width=650 persistent fluid scrollable content-class="round-2xl")
    v-card
      v-card-title.pa-4
        v-spacer
        .text-xl.font-bold.ml-10 Sales report in progress
        v-spacer
        v-btn(icon @click="closeDialog" small color="primary")
          v-icon mdi-close
      v-divider

      v-card-text.pa-8.text-sm.neutral700--text
        div We have started generating the sales report in the background.
        div You can continue to use the application while we process the report.
        div We will send the report via email once the report is ready.
        div.mt-4(v-if="receiverEmails") Email : {{ receiverEmails.join(', ') }}

      v-divider
      v-card-actions.py-4.px-6
        v-spacer
        v-btn.button-md(color="primary" depressed @click="closeDialog") Close
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean
    },
    receiverEmails: {
      type: Array,
      default: null
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    }
  }
}
</script>